import { ServiceItem } from 'orderme-api-integration-client';
import { store } from '../redux/store';

export const round2 = (value: number): number => Math.round(value * 100) / 100;

export const getServicePrice = (service: ServiceItem, amount: number, useOriginalPrice?: boolean) => {
  if (useOriginalPrice) {
    return service.originalPrice;
  }

  var price = service.price;
  if (amount <= 0) {
    return price;
  }

  if (service.prices?.length > 0) {
    var newPrice = service.prices.sort((a, b) => b.amount - a.amount).find((p) => amount >= p.amount)?.price;
    if (newPrice < price) {
      price = newPrice;
    }
  }

  return round2(price);
};

export const getMaxCreditsCanBeUsed = () => {
  var pricePaidWithCredits = getCartWorthPaidWithCredits();
  const packingFee = getPackingFee();
  if (packingFee > 0) {
    pricePaidWithCredits += packingFee;
  }

  const discount = store.getState().shoppingCartState.couponDiscount ?? 0;
  if (discount > 0) {
    pricePaidWithCredits -= discount;
  }

  // Item prices are client-side (loyalty) prices; the server total already reflects the coupon
  // when it beats the loyalty discount, so never allow more credits than the server cart total.
  const cartTotal = getCartTotalWithoutDelivery();
  if (pricePaidWithCredits > cartTotal) {
    pricePaidWithCredits = cartTotal;
  }
  if (pricePaidWithCredits < 0) {
    pricePaidWithCredits = 0;
  }

  const credits = store.getState().customerState.customerInfo.credit ?? 0;

  return round2(pricePaidWithCredits > credits ? credits : pricePaidWithCredits);
};

const getCartWorthPaidWithCredits = () => {
  var servicesInBasket = getServicesInBasket();
  if (servicesInBasket.length === 0) {
    return 0;
  }

  const sum = servicesInBasket.reduce(
    (acc, { serviceItem, count }) =>
      acc + (serviceItem.canBePaidWithCredits ? getServicePrice(serviceItem, count, !isLoggedIn()) * count : 0),
    0
  );
  return round2(sum);
};

const getCartTotalWithoutDelivery = () => {
  const { totalPrice, packsPrice, couponDiscount } = store.getState().shoppingCartState;
  return round2((totalPrice ?? 0) + (packsPrice ?? 0) - (couponDiscount ?? 0));
};

const getServicesInBasket = () => store.getState().shoppingCartState.items;
const getPackingFee = () => store.getState().shoppingCartState.packsPrice;
const isLoggedIn = () => store.getState().authState.isLoggedIn;
